import React, { useState, useEffect } from 'react';
import InstaGrid from "./InstaGrid";
import InstaItem from "./InstaItem";
import { Loader } from '../Loader/Loader'
import {
    mediaServiceEndpoint,
} from '../../assets/data/constants';

const InstaFeed = () => {
    const [instaItems, setInstaItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {

        const fetchMedia = async (id: string) => {
            const mediaUrl = `${mediaServiceEndpoint}?action=instamedia&id=${id}`;

            const res = await fetch(mediaUrl);
            const json = (await res.json());

            if (json.error) {
                throw new Error(json.error);
            }

            const instaItem: InstaItem = {
                permalink: json.permalink,
                mediaUrl: json.media_url,
                caption: json.caption
            };

            return instaItem;
        };

        const doFetch = async() => {
            setLoading(true);
            setError(null);
            const instaUrl = `${mediaServiceEndpoint}?action=instafeed`;

            try {
                const res = await fetch(instaUrl);
                const body = await res.json();

                if (body.error) {
                    throw new Error(body.error);
                }

                const json = body.data || [];
                const fetchedItems: InstaItem[] = [];

                for (let i = 0; i < json.length && i < 9; i++) {
                    const item = json[i];
                    const itemId = item.id;
                    const instaItem = await fetchMedia(itemId);
                    fetchedItems.push(instaItem);
                }

                setInstaItems(fetchedItems);
            } catch (e) {
                setError(e.message || 'Не вдалося завантажити стрічку Instagram');
            } finally {
                setLoading(false);
            }
        };

        doFetch();

    }, []);

    return (
        loading ? (
            <Loader />
        ) : (
            <InstaGrid items={instaItems} error={error} />
        )
    );

}

export default InstaFeed;
